module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "epigraph",
      "role": "doc-chapter"
    }
  }, [_c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "slh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vi",
      "id": "pvi",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vii",
      "id": "pvii",
      "role": "doc-pagebreak"
    }
  }), _vm._v("A Noiseless patient spider")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("A noiseless, patient spider,")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("I mark’d, where, on a little promontory, it stood, isolated;")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("Mark’d how, to explore the vacant, vast surrounding,")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("It lauch’d forth filament, filament, filament, out of itself;")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("Ever unreeling them—ever tirelessly speeding them.")]), _vm._v(" "), _c('p', {
    staticClass: "slf"
  }, [_vm._v("And you, O my Soul, where you stand,")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("Surrounded, surrounded, in measureless oceans of space,")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("Ceaselessly musing, venturing, throwing,—seeking spheres, to connect them;")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("Till the bridge you will need, be form’d—till the ductile anchor hold;")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("Till the gossamer thread you fling, catch somewhere, O my Soul.")]), _vm._v(" "), _c('p', {
    staticClass: "slt"
  }, [_vm._v("—Walt Whitman")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51adb9f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-eberhard-0007.vue
// module id = 72
// module chunks = 0